import script from "./CrmContactsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrmContactsPage.vue?vue&type=script&setup=true&lang=ts"

import "./CrmContactsPage.vue?vue&type=style&index=0&id=c5550228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5550228"]])

export default __exports__